<template>
  <div>
    <Breadcrumbs main="Inventario" title="Editar Vehículo" v-if="objectId"/>
    <Breadcrumbs main="Inventario" title="Agregar Vehículo" v-else/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5 v-if="objectId">Editar Vehículo</h5>
              <h5 v-else>Agregar Vehículo</h5>
            </div>
            <div class="card-body">
              <b-form class="needs-validation">
                <div class="form-row">
                  <div class="col-md-12 mb-3">
                    <label>Patente (requerido)</label>
                    <b-form-input
                            type="text" id="stock_id" placeholder="ABCD-12"
                            v-model="form.patent.value">
                    </b-form-input>
                    <b-form-invalid-feedback :state="form.patent.is_valid">{{form.patent.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="type_id">Tipo de transporte (requerido)</label>
                    <multiselect placeholder="Selecciona un tipo de transporte" id="type_id"
                                 label="name" track-by="id"
                                 deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                                 v-model="form.type.value" :options="form.type.options"
                                 :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
                      <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                    </multiselect>
                    <b-form-invalid-feedback :state="form.type.is_valid">{{form.type.message_error}}</b-form-invalid-feedback>
                  </div>
                  <b-button type="button" variant="primary" @click="onSubmit" v-if="objectId">Editar vehículo</b-button>
                  <b-button type="button" variant="success" @click="onSubmit" v-else>Agregar vehículo</b-button>
                  <b-button type="button" variant="warning" class="ml-1" :to="{'name': 'RouteVehicleList'}">Volver</b-button>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import axios from 'axios';
  import Multiselect from 'vue-multiselect';
  import utils from '../../../utils';

  export default {
    components: {
      Multiselect
    },
    data(){
      return {
        objectId: null,
        form: {
          patent: utils.defaultFields(),
          type: utils.defaultFields({
            _type: 'select',
            options: utils.statusVehicle
          }),
        },
      }
    },
    async mounted () {
      this.objectId = this.$route.params.objectId;
      if(this.objectId){
        await this.loadData(this.objectId);
      }
    },
    methods: {
      onSubmit(evt){
        // console.log(evt)
        evt.preventDefault();
        // AQUÍ GUARDARÉ EL JSON FINAL PARA QUE SEA ENVIADO AL POST
        let data = {};
        const is_valid = utils.generateJsonStructure(this.form, data);
        if(is_valid){
          let _type = 'agregar un vehículo';
          if(this.objectId){
            _type = 'modificar un vehículo'
          }
          this.$swal({
            title: 'Información',
            type: 'info',
            html: `Estás a punto de ${_type}.`,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#28a745',
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
            cancelButtonColor: '#dc3545',
            cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              if(!this.objectId){
                const path = '/api/route/v1.0/vehicle/';
                await axios.post(path, data).then(async () => {
                  // console.log(response);
                  await this.$swal({
                    title: 'Agregado',
                    type: 'success',
                    html: `Se ha agregado el vehículo de manera correcta.`,
                  }).then(() => {
                    this.$router.push({'name': 'RouteVehicleList'});
                  });
                }).catch(async (error) => {
                  // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                  console.log(error.response);
                  if(error.response.status === 400){
                    utils.generateBackendError(this.form, error.response.data);
                    await this.$swal({
                      title: 'Error',
                      type: 'error',
                      html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                    });
                  }
                });
              } else {
                const path = `/api/route/v1.0/vehicle/${this.objectId}/`;
                await axios.patch(path, data).then(async () => {
                  // console.log(response);
                  await this.$swal({
                    title: 'Modificado',
                    type: 'success',
                    html: `Se ha modificado el vehículo de manera correcta.`,
                  }).then(() => {
                    this.$router.push({'name': 'RouteVehicleList'});
                  });
                }).catch(async (error) => {
                  // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                  console.log(error.response);
                  if(error.response.status === 400){
                    utils.generateBackendError(this.form, error.response.data);
                    await this.$swal({
                      title: 'Error',
                      type: 'error',
                      html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                    });
                  }
                });
              }
            }
          });
        }else{
          this.$swal({
            title: 'Error',
            type: 'error',
            html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
          });
        }
      },
      async loadData(objectId){
        let data = {};
        let responseData;
        const defaultFieldValues = {
          type: {
            _type: 'select',
            options: utils.statusVehicle
          },
        };
        const path = `/api/route/v1.0/vehicle/${objectId}/`;
        await axios.get(path).then(async (response) => {
          responseData = response.data;
          await utils.loadDataStructure(data, responseData, defaultFieldValues);

        }).catch((error) => {
          console.log(error.response);
        });
        data['type'].value = data['type'].options.find(item => item['id'] === data['type'].value);
        await this.$set(
            this,
            'form',
            data
        );
      }
    }
  }
</script>